import Panel from './panel';

export default Panel;



// WEBPACK FOOTER //
// ./src/components/panel/index.js